/**
 * العربية هي المصدر: كل معرِّف رسالة يُضاف هنا أولاً، ومنه تُشتقّ أنواع الطبقة كلها.
 * المعرِّفات ثابتة ولا تُعاد تسميتها — النص هو ما يتغيّر.
 * أي مفتاح ناقص في قاموس آخر يرجع إلى قيمته هنا، فلا يظهر مفتاح خام على الشاشة أبداً.
 */
export const ar = {
  /* ── عامة ─────────────────────────────────────────────────────────── */
  'app.title': 'منصة رفرفة',
  'app.brandAria': 'منصة رفرفة — الصفحة الرئيسية',
  'common.login': 'دخول',
  'common.home': 'الصفحة الرئيسية',
  'common.signOut': 'خروج',
  'common.signOutLong': 'تسجيل الخروج',
  'common.openMenu': 'فتح القائمة',
  'password.show': 'إظهار كلمة المرور',
  'password.hide': 'إخفاء كلمة المرور',
  'password.capsLock': 'Caps Lock مفعّل — الحروف تُكتب كبيرة.',
  'common.closeMenu': 'إغلاق القائمة',
  'common.mainNav': 'التنقل الرئيسي',
  'common.loadingSession': 'جارٍ التحقق من الجلسة…',
  'common.loadingScreen': 'جارٍ تحميل الشاشة…',
  'common.available': 'متاح',
  'common.unavailable': 'غير متاح',

  /* ── قشرة الطالب (KidShell) ───────────────────────────────────────── */
  'brand.name': 'رفرفة',
  'kid.rafif.name': 'رفيف',
  'kid.rafif.bubble': 'أنا رفيف، أساعدك',
  'kid.nav.home': 'صفحتي',
  'kid.nav.class': 'الفصل الإلكتروني',
  'kid.nav.school': 'مدرستي',
  'kid.nav.homework': 'واجباتي',
  'kid.nav.inbox': 'صندوق الوارد',
  'kid.nav.grades': 'درجاتي',
  'kid.nav.games': 'تماريني',
  'kid.nav.reports': 'تقاريري',
  'kid.nav.recommendations': 'توصيات المرشد',
  'kid.nav.aria': 'أقسام صفحتي',
  'kid.unread': '{count} غير مقروء',
  'kid.intro.home': 'هذه صفحتك — كل ما يخصّك في مكان واحد.',
  'kid.intro.class': 'هنا حصصك على الإنترنت: ما يجري الآن وما سيأتي.',
  'kid.intro.school': 'هذه مدرستك ومعلّموك — تستطيع أن تراسلهم من هنا.',
  'kid.intro.homework': 'هذه واجباتك: الجديد منها، وما أرسلته، وما راجعه معلّمك.',
  'kid.intro.grades': 'هذه درجاتك في كل مادة بعد أن تنشرها مدرستك.',
  'kid.intro.inbox': 'هنا الرسائل والأخبار التي وصلتك.',
  'kid.intro.games': 'اختر تمريناً قصيراً — وتستطيع التوقف متى شئت.',

  /* ── مبدِّل المظهر واللغة ──────────────────────────────────────────── */
  'theme.label': 'الوضع الليلي',
  'theme.system': 'حسب النظام',
  'theme.light': 'الوضع النهاري',
  'theme.dark': 'الوضع الليلي',
  'theme.switchTo': 'تغيير المظهر — الحالي: {current}، والتالي: {next}',
  'lang.label': 'اللغة',
  'lang.ar': 'العربية',
  'lang.en': 'English',
  'lang.switchTo': 'تغيير اللغة إلى {next}',

  /* ── الأدوار والمسارات (ما يظهر في رأس المنصة) ─────────────────────── */
  'role.PLATFORM_ADMIN': 'إدارة المنصة',
  'role.PLATFORM_SUPPORT': 'قسم خدمة المستفيدين',
  'role.PLATFORM_ACADEMIES': 'قسم الأكاديميات والدورات',
  'role.PLATFORM_INSTITUTIONS': 'قسم المراكز والمدارس',
  'role.PLATFORM_FINANCE': 'القسم المالي',
  'role.INSTITUTION_ADMIN': 'إدارة المؤسسة',
  'role.INTERNAL_SUPERVISOR': 'مشرف داخلي',
  'role.SPECIALIST': 'أخصائي',
  'role.COUNSELOR': 'مرشد طلابي',
  'role.TEACHER': 'معلم',
  'role.PARENT': 'ولي أمر',
  'role.STUDENT': 'طالب',
  'role.PROFESSIONAL': 'حساب مهني',
  'role.REGULATORY_SUPERVISOR': 'مشرف رقابي',
  'role.CLIENT': 'مستفيد',
  'role.OFFICE_STAFF': 'موظف إداري',
  'role.INSTITUTION_DELEGATE': 'مفوَّض عن الإدارة',
  'role.GRANT_ATTENDANCE': 'صلاحية الحضور والغياب',
  'role.GRANT_CLASS_RECORDING': 'صلاحية تسجيل الحصة',
  'track.SPECIAL_EDUCATION': 'مسار التربية الخاصة',
  'track.COUNSELING': 'مسار الإرشاد',
  'institutionType.CENTER': 'مركز',
  'institutionType.SCHOOL': 'مدرسة',

  /* ── رأس المنصة ───────────────────────────────────────────────────── */
  'shell.noRole': 'بلا دور فعّال',
  'shell.switchInstitution': 'تبديل المؤسسة',
  'shell.platformScopeOption': '— نطاق المنصة (بلا مؤسسة) —',
  'shell.platformScope': 'نطاق المنصة',
  'shell.regulatorScope': 'حساب الجهة الرقابية',
  'shell.effectiveRole': 'الدور الفعّال:',

  /* ── مجموعات التنقل وعناصره ───────────────────────────────────────── */
  'nav.group.oversight': 'الجهة الرقابية',
  'nav.group.platform.institutions': "المنصة — المؤسسات",
  'nav.group.platform.accounts': "المنصة — الحسابات",
  'nav.group.platform.money': "المنصة — المال والشكاوى",
  'nav.group.platform.content': "المنصة — المحتوى",
  'nav.group.platform.audit': "المنصة — المتابعة والتدقيق",
  'nav.group.platform': 'المنصة',
  'nav.group.institution': 'المؤسسة',
  'nav.group.me': 'حسابي',
  'nav.oversight.linked': 'الإشراف',
  'nav.platform.institutions': 'المؤسسات',
  'nav.platform.regulatory': 'الجهات الرقابية',
  'nav.platform.regulators': 'حسابات الجهات الرقابية',
  'nav.platform.consentTexts': 'نصوص الموافقات',
  'nav.platform.seatRequests': 'طلبات زيادة المقاعد',
  'nav.platform.audit': 'تدقيق المنصة',
  'nav.platform.notes': 'ملاحظات التحسين',
  'nav.platform.myAudit': 'سجلّ أفعالي',
  'nav.app.dashboard': 'الرئيسية',
  'nav.app.review': 'مركز المراجعة',
  'nav.app.students': 'الطلبة',
  'nav.app.linkRequests': 'طلبات الربط',
  'nav.app.plans': 'الخطط والأهداف',
  'nav.app.preparations': 'التحضير اليومي',
  'nav.app.sessions': 'الجلسات',
  'nav.app.reports': 'التقارير',
  'nav.app.caseload': 'الطلبة المسندون إليك',
  'nav.app.caseloadAdmin': 'إسناد الطلبة',
  'nav.app.counseling': 'ملف الإرشاد',
  'nav.app.referrals': 'طلبات الإحالة',
  'nav.app.users': 'الحسابات والعضويات',
  'nav.app.orgChart': 'الهيكل التنظيمي',
  'nav.app.holidays': 'العطل',
  'nav.app.leave': 'طلبات الإجازة',
  'nav.app.homeSession': 'تسجيل جلسة للأهل',
  'nav.app.myAttendance': 'حضوري ودوامي',
  'nav.app.staffAttendance': 'حضور الكادر',
  'nav.app.complaints': 'صندوق الشكاوى',
  'nav.app.approvals': 'سلاسل الموافقة',
  'nav.platform.holidays': 'العطل الرسمية',
  'nav.app.invitations': 'الدعوات',
  'nav.app.credentials': 'شهادات الموظفين',
  'nav.app.settings': 'إعدادات المؤسسة',
  'nav.app.branding': 'البطاقة التعريفية',
  'nav.app.alerts': 'التنبيهات',
  'nav.app.indicators': 'المؤشرات',
  'nav.app.rules': 'القواعد',
  'nav.app.excellence': 'التميّز المهني',
  'nav.app.broadcast': 'تسجيل الحصص',
  'nav.app.regulatoryScope': 'ما تشاركه مع الجهات',
  'nav.app.integration': 'ما يغادر مؤسستك',
  'nav.app.billing': 'الاشتراك والفوترة',
  'nav.app.jobs': 'التوظيف والدليل',
  'nav.app.continuity': 'حزمة الاستمرارية',
  'nav.app.audit': 'سجل التدقيق',
  'nav.me.assignments': "الواجبات",
  'nav.me.class': 'طلبتي',
  'nav.me.rosterPlans': 'خطط طلبتي',
  'nav.me.referrals': 'طلبات الإحالة للطلبة',
  'nav.me.timetable': 'جدول حصصي',
  'nav.app.classrooms': 'الصفوف والشُّعب',
  'nav.app.academics': 'الإعداد الأكاديمي',
  'nav.app.worksheets': 'أوراق العمل',
  'kid.nav.timetable': 'جدول حصصي',
  'nav.me.home': 'الصفحة الأولى',
  'nav.me.drafts': 'المسودات',
  'nav.me.children': 'أبنائي',
  'nav.me.reports': 'تقارير أبنائي',
  'nav.me.reports.student': 'تقاريري',
  'nav.me.recommendations': 'توصيات المرشد',
  'nav.me.consents': 'الموافقات والتوقيع',
  'nav.me.excellence': 'درجتي المهنية',
  'nav.me.classBroadcasts': 'حصص صفّ ابني المسجَّلة',
  'nav.me.jobs': 'فرص العمل وشهاداتي',
  'nav.me.continuity': 'حزم أبنائي',
  'nav.me.professional': 'ملفي المهني',
  'nav.me.invitations': 'دعوات الارتباط',

  /* ── غلاف الصفحات العامة ──────────────────────────────────────────── */
  'public.nav.aria': 'الصفحات العامة',
  'public.nav.directory': 'الأدلة العامة',
  'centers.title': 'المؤسسات',
  'centers.sub': 'المؤسسات النشطة التي اختارت الظهور — اختر مدينتك أو ابحث بالاسم.',
  'centers.join': 'ضُمّ مركزك أو مدرستك إلى رفرفة',
  'centers.search': 'ابحث بالاسم',
  'centers.search.hint': '',
  'centers.city': 'المدينة',
  'centers.city.all': 'كل المدن',
  'centers.city.hint': '{n} مدينةً فيها جهاتٌ مُدرجة.',
  'centers.city.empty': 'لا مدنَ بعد — تظهر حين تُدرج أول جهة.',
  'centers.tab.centers': 'المراكز',
  'centers.tab.schools': 'المدارس',
  'centers.tabs.aria': 'نوع الجهة',
  'centers.loading': 'جارٍ تحميل المؤسسات…',
  'centers.empty.center': 'لا مراكز مدرجة بعد',
  'centers.empty.school': 'لا مدارس مدرجة بعد',
  'centers.none.center': 'لا مركز يطابق بحثك',
  'centers.none.school': 'لا مدرسة تطابق بحثك',
  'centers.empty.text': 'الظهور هنا اختيار كل جهة — وحين تختاره تظهر في هذه الصفحة فوراً.',
  'centers.none.text': 'جرّب اسماً أقصر، أو «كل المدن»، أو انظر في التبويب الآخر.',
  'centers.clear': 'أزل التصفية',
  'centers.map': 'الموقع على خرائط جوجل',
  'centers.alsoSchool': 'ومدرسة',
  'centers.privacy': 'لا يظهر في هذه الصفحة بريد ولا هاتف ولا رقم هوية، ولا يظهر عن كل جهةٍ إلا ما اختارت نشرَه بنفسها. التواصل يمرّ عبر المنصة: دعوةٌ يقبلها صاحب الحساب.',
  'centers.logoAlt': 'شعار {name}',
  'institutionType.CENTER.short': 'مركز',
  'institutionType.SCHOOL.short': 'مدرسة',
  'public.nav.verify': 'التحقّق',
  'public.nav.news': 'الأخبار',
  'public.nav.open': 'فتح قائمة الأقسام',
  'public.nav.close': 'إغلاق قائمة الأقسام',
  'public.footer.rights': '© {year} منصة رفرفة',

  /* ── الصفحة الرئيسية ──────────────────────────────────────────────── */
  'landing.nav.aria': 'أقسام الصفحة',
  'landing.nav.who': 'لمن',
  'landing.nav.journey': 'كيف تعمل',
  'landing.nav.news': 'الأخبار',
  'landing.nav.public': 'الأدلة العامة',
  'landing.cta.professional': 'حساب مهني',
  'landing.hero.kicker': 'المنصّة العربيّة المتكاملة لتشغيل التعليم والتربية الخاصة والإرشاد',
  'landing.hero.slogan': 'كل رفرفة تحمل إمكانية التغيير',
  'landing.hero.tagline': 'الجميع يقدمون الخدمات ورفرفة تقدم الحلول',
  'landing.cta.guardian': 'حساب وليّ أمر',
  'landing.hero.guardianNote': 'وليّ الأمر يبدأ بنفسه: أنشئ حسابك وأضف أولادك ثم اطلب ربطهم بمؤسساتهم.',
  'landing.aud.open': 'اطّلع على التفاصيل',
  'landing.aud.aria': 'لماذا رفرفة — لكل طرف',
  'landing.aud.inst.t': 'لماذا رفرفة للمراكز؟',
  'landing.aud.inst.1.t': 'تشغيلٌ مؤسسيٌّ متكامل',
  'landing.aud.inst.1.d': 'البنيةُ التشغيليّة اليوميّة لمؤسستك في مساحةٍ واحدة — من ملفات الطلبة والخطط والتقارير، إلى السجل المهني للأخصائيين، والمهام والعمليات المتكرّرة، بما يساعد على تنظيم العمل ومتابعته بكفاءة.',
  'landing.aud.inst.2.t': 'رقابةٌ حيّةٌ على العمليات',
  'landing.aud.inst.2.d': 'شفافيّةٌ أوضح في تقديم الخدمة ومتابعتها — من خلال التوثيق المصوّر، والبثّ المباشر عند الحاجة، والخطط الفرديّة الموثّقة، بما يتيح متابعة سير العمل وجودة تنفيذ الخدمات.',
  'landing.aud.inst.3.t': 'حضورٌ مهنيٌّ لمؤسستك',
  'landing.aud.inst.3.d': 'وجودٌ رقميٌّ يعكس هوية مؤسستك وخبرتها — صفحةٌ تعريفية متكاملة تُبرز خدماتك وتخصصاتك وفريق العمل وإنجازاتك، وتسهّل وصول الأسر إليك والتعرّف على خدماتك.',
  'landing.aud.inst.4.t': 'واجهةٌ رقميّة تُقدّم مؤسستك',
  'landing.aud.inst.4.d': 'صفحةٌ متكاملة تربط المؤسسة بالأهالي — تتضمّن التعريف بالمؤسسة وخدماتها وفريقها، مع بوابةٍ مخصّصة لتسجيل الأهالي والتعرّف على الخدمات المناسبة لاحتياجات أبنائهم.',
  'landing.aud.inst.5.t': 'بابٌ مفتوحٌ على الكفاءات والفرص',
  'landing.aud.inst.5.d': 'منظومةٌ تساعدك على استقطاب الكفاءات والإعلان عن فرص العمل — من خلال الوصول إلى شبكةٍ متخصّصة من المختصين والعاملين في مجالات التربية الخاصة والإرشاد، والبحث عن الكفاءات وفق التخصص والخبرة.',
  'landing.aud.inst.6.t': 'شراكةٌ مستمرةٌ مع أولياء الأمور',
  'landing.aud.inst.6.d': 'قناةٌ مباشرة تربط المؤسسة بالأسرة في رحلة الطالب — تتيح للإدارة مشاركة التوصيات والتحديثات اليومية، والتواصل مع أولياء الأمور، وإبقاءهم على اطّلاعٍ مستمر بما يتعلّق بتقدّم أبنائهم وخططهم واحتياجاتهم.',
  'landing.aud.school.t': 'لماذا رفرفة للمدارس؟',
  'landing.aud.school.1.t': 'تشغيلٌ مؤسسيٌّ متكامل',
  'landing.aud.school.1.d': 'البنيةُ التشغيليّة اليوميّة لمدرستك في مساحةٍ واحدة — من ملفات الطلبة والخطط والتقارير، إلى إدارة الفريق والمهام والعمليات المتكرّرة، بما يساعد على تنظيم العمل ومتابعته بكفاءة.',
  'landing.aud.school.2.t': 'ملفٌّ تراكميٌّ لكل طالب',
  'landing.aud.school.2.d': 'ملفٌّ إرشاديٌّ وسلوكيٌّ يرافق كلَّ طالبٍ طوال سنوات دراسته، وملفُّ تربيةٍ خاصة للطلبة الذين يحتاجون إلى خدماتها، مع إمكانية انتقال المعلومات بموافقة وليّ الأمر عند انتقال الطالب إلى مدرسةٍ أخرى.',
  'landing.aud.school.3.t': 'نظامُ إحالةٍ موحَّد',
  'landing.aud.school.3.d': 'يتيح للمعلّم رفعَ طلب إحالةٍ عند ملاحظة احتياجٍ يستدعي المتابعة، وتوجيهَه إلى المختصّ المناسب، مع توثيق سبب الإحالة ومسارها والإجراءات المتّخذة.',
  'landing.aud.school.4.t': 'نظامُ تشغيلٍ للتعليم المساند',
  'landing.aud.school.4.d': 'منظومةٌ متكاملة لإدارة خدمات التعليم المساند داخل المدرسة؛ من إعداد الخطط الفردية وجدولة الجلسات، إلى توثيق تنفيذها كتابياً أو مصوَّراً، وتسجيل الملاحظات والتوصيات ورفع التقارير ومتابعة تقدّم الطالب.',
  'landing.aud.school.5.t': 'رقابةٌ حيّةٌ على العمليات',
  'landing.aud.school.5.d': 'متابعةٌ أوضح لسير تقديم الخدمات من خلال التوثيق المصوّر، والبثّ المباشر عند الحاجة، والخطط الفردية الموثّقة، بما يدعم متابعة تنفيذ الخدمة وجودتها.',
  'landing.aud.school.6.t': 'مساحاتٌ مهنيةٌ خاصة',
  'landing.aud.school.6.d': 'مساحةٌ مستقلّة للمرشد التربوي وأخصائي التربية الخاصة لتسجيل الملاحظات والتوصيات ومتابعة الحالات، مع تحديد ما يُشارَك مع وليّ الأمر وما يبقى ضمن السجل المهني.',
  'landing.aud.school.7.t': 'تواصلٌ مباشرٌ مع الأسرة',
  'landing.aud.school.7.d': 'قناةٌ منظّمة تربط المدرسة بأولياء الأمور لمشاركة التوصيات والتحديثات، ومتابعة احتياجات الطالب وتقدّمه، والتواصل المباشر مع الإدارة والمختصين.',
  'landing.aud.school.8.t': 'جلساتٌ إرشاديةٌ ومساندة',
  'landing.aud.school.8.d': 'إتاحةُ حجز الجلسات الإرشادية والمساندة للطالب أو وليّ الأمر، أونلاين أو حضورياً، بحسب الخدمات التي توفّرها المدرسة.',
  'landing.aud.school.9.t': 'بابٌ مفتوحٌ على الكفاءات والفرص',
  'landing.aud.school.9.d': 'منظومةٌ تساعد المدرسة على استقطاب الكفاءات والإعلان عن فرص العمل، والوصول إلى مختصين في التربية الخاصة والإرشاد والتعليم وفق التخصص والخبرة.',
  'landing.aud.school.10.t': 'متابعةٌ وتقارير متكاملة',
  'landing.aud.school.10.d': 'لوحاتٌ وتقارير تساعد المدرسة على متابعة الإرشاد والتربية الخاصة والتعليم المساند، ومراجعة تنفيذ الخطط والخدمات واحتياجات الطلبة.',
  'landing.aud.school.11.t': 'بوابةٌ متكاملة للأهالي',
  'landing.aud.school.11.d': 'مساحةٌ رقمية تتيح للأهالي التعرّف على المدرسة وخدماتها، وإتمام التسجيل، ومتابعة ما يخصّ أبناءهم والتواصل مع الجهة التعليمية من حساباتهم.',
  'landing.aud.parent.t': 'لماذا رفرفة لأولياء الأمور؟',
  'landing.aud.parent.lead': 'كلُّ ما يخصّ طفلك في مكانٍ واحد.',
  'landing.aud.parent.1': 'يمنحك رفرفة ملفاً تراكمياً موحّداً ترافقه تقاريره وخططه وتقييماته عبر مراحل رحلته، مع إمكانية التحكّم فيمن يمكنه الاطّلاع على معلوماته ومشاركتها مع أكثر من مؤسسة أو مختصٍّ عند الحاجة.',
  'landing.aud.parent.2': 'تتواصل مباشرةً مع المؤسسة المرتبط بها طفلك، وتتابع تقدّمه أولاً بأول من خلال تقارير مبسّطة وتوصيات واضحة تساعدك على فهم ما يحدث ومتابعته في المنزل.',
  'landing.aud.parent.3': 'كما يتيح لك رفرفة الوصول إلى دليلٍ موثّق للمؤسسات والأخصائيين والاستشاريين، وحجز جلسات الإرشاد لك أو لطفلك، أونلاين أو حضورياً، مباشرةً من حسابك.',
  'landing.aud.parent.4': 'وتجد أيضاً دوراتٍ وموارد توعوية مخصّصة للأهل، تساعدك على فهم رحلة طفلك واتخاذ خطواتٍ أكثر وعياً وثقة.',
  'landing.aud.pro.t': 'لماذا رفرفة للأخصائيين والاستشاريين والمدرّبين؟',
  'landing.aud.pro.1.t': 'ملفٌّ مهنيٌّ تراكمي',
  'landing.aud.pro.1.d': 'صفحةٌ مهنية تجمع تخصصك وخبراتك وخدماتك وإنجازاتك، ليصل إليك من يبحث عن خبرتك. وملفُّك ينتقل معك أينما كنت: يوثّق خبراتك وساعات جلساتك وإنجازاتك وشهاداتك في سجلٍّ مهنيٍّ واحد.',
  'landing.aud.pro.2.t': 'توثيق ساعات العمل والخبرة',
  'landing.aud.pro.2.d': 'تُحتسب ساعات الجلسات والعمل داخل المنصة، لتبقى خبرتك المهنية موثّقة وقابلة للرجوع إليها.',
  'landing.aud.pro.3.t': 'شهادة تميّز',
  'landing.aud.pro.3.d': 'إنجازاتك تصنع مسيرتك — تُمنح شهادة التميّز وفق معايير الإنجاز والأداء الموثّق داخل المنصة.',
  'landing.aud.pro.4.t': 'فرص عمل',
  'landing.aud.pro.4.d': 'ابحث عن فرصٍ تناسب تخصصك وخبرتك من بين ما تعلنه المراكز والمدارس والمؤسسات عبر بوابةٍ مهنية متخصّصة — أو تجدك المؤسسات هي.',
  'landing.aud.pro.5.t': 'أكاديميةٌ خاصة للمدرّبين',
  'landing.aud.pro.5.d': 'للمدرّبين الحاصلين على الاعتماد من هيئة الاعتماد والجودة: مساحةٌ خاصة لتقديم الدورات واستقطاب المتدرّبين.',
  'landing.aud.pro.6.t': 'جلساتٌ واستشارات',
  'landing.aud.pro.6.d': 'قدّم جلساتك واستشاراتك أونلاين، وحدّد مواعيدك وأسعارك من حسابك.',
  'landing.aud.pro.7.t': 'أدواتٌ مهنية',
  'landing.aud.pro.7.d': 'أدواتٌ تساعدك في التقييم، والتخطيط، وإعداد التقارير، وتنظيم العمل.',
  'landing.who.kicker': 'لمن',
  'landing.who.title': 'خمسة أطراف، ولكلٍّ بابه',
  'landing.who.lead': 'المنصة واحدة والقواعد واحدة — وما يختلف هو ما يراه كل طرف وما يستطيع فعله.',
  'landing.door.centers.t': 'مراكز التربية الخاصة والإرشاد',
  'landing.door.centers.d': 'تشغيل كامل للمسارين: تقييم، وخطة، وأهداف، وتحضير، وجلسات مسجَّلة، وتقارير بثلاثة جماهير، ومؤشرا جودة وحماية.',
  'landing.door.centers.cta': 'دخول المؤسسة',
  'landing.door.schools.t': 'المدارس',
  'landing.door.schools.d': 'ملف إرشادي لكل طالب لا للمتعثّرين وحدهم، وروستر للمعلّم، وإحالة موثَّقة، وبثّ الفصل لأولياء أمور طلبته بموافقة أهل كل طفل.',
  'landing.door.schools.cta': 'دخول المدرسة',
  'landing.door.pros.t': 'المختصون والمرشدون',
  'landing.door.pros.d': 'حساب مهني تملكه أنت لا المؤسسة: ينتقل معك بشهاداتك وسجلّك ودرجتك، وتقبل دعوات المؤسسات أو ترفضها.',
  'landing.door.pros.cta': 'أنشئ حسابك المهني',
  'landing.door.families.t': 'الأسر',
  'landing.door.families.d': 'حساب يوقّع منه وليّ الأمر الموافقات بنفسه، ويقرأ ما نُشر لابنه، ويشاهد بثّ صفّه — ولا يرى ملاحظات المختص الداخلية.',
  'landing.door.families.cta': 'وصلك رابط تفعيل؟',
  'landing.door.regulators.t': 'الجهات الرقابية',
  'landing.door.regulators.d': 'لوحة امتثال للمؤسسات المرتبطة بالجهة: أعداد ونسب ودرجات — بلا اطّلاع على سجلٍّ فردي عن طفل أو موظف.',
  'landing.door.regulators.cta': 'دخول المشرف الرقابي',
  'landing.journey.kicker': 'كيف تعمل',
  'landing.journey.title': 'رحلة الخدمة في عشر محطات',
  'landing.journey.lead': 'هذه المحطات ليست وصفاً: اختبارٌ آلي يمشيها كلها قبل كل تسليم ويقارن سجلّ التدقيق بترتيب ما وقع. إن سقط، فالخدمة لا تُقدَّم.',
  'landing.step.1.t': 'المؤسسة',
  'landing.step.1.d': 'تُنشأ وتُربط تلقائياً بجهتها المشرفة الإلزامية',
  'landing.step.2.t': 'الكادر',
  'landing.step.2.d': 'مشرفون داخليون لكل مسار، ومعلّمون، ومختصون بالدعوة',
  'landing.step.3.t': 'الطالب وأسرته',
  'landing.step.3.d': 'تسجيل بفحص تكرار، ودعوة وليّ الأمر، وتوقيعه بنفسه',
  'landing.step.4.t': 'الخطة والأهداف',
  'landing.step.4.d': 'المختص يكتب، والمشرف يراجع، والإدارة تعتمد',
  'landing.step.5.t': 'التحضير والجلسة',
  'landing.step.5.d': 'لا جلسة بلا تحضير؛ والتسجيل يبدأ وينتهي معها',
  'landing.step.6.t': 'التقرير',
  'landing.step.6.d': 'نصٌّ للداخل، ونصٌّ للأسرة، ونصٌّ للطالب',
  'landing.step.7.t': 'المراجعة والاعتماد',
  'landing.step.7.d': 'من كتب لا يراجع، ومن راجع لا يعتمد',
  'landing.step.8.t': 'الإحالة',
  'landing.step.8.d': 'التوثيق قبل القرار، وإحالة الإرشاد تُقبل إلزامياً',
  'landing.step.9.t': 'القواعد والمؤشرات',
  'landing.step.9.d': 'تمريرة ليلية تكنس وتنبّه وتحسب الجودة والحماية',
  'landing.step.10.t': 'الإشراف',
  'landing.step.10.d': 'الجهة ترى مجاميع الامتثال، وكل اطّلاع يُسجَّل',
  'landing.rules.kicker': 'قواعد لا تنتظر إعداداً',
  'landing.rules.title': 'بُنيت في الخادم وقاعدة البيانات، لا في الشاشة',
  'landing.rules.lead': 'فلا يتجاوزها خطأ في واجهة، ولا تعديلٌ من مستخدم، ولا نداءٌ مباشر إلى الواجهة البرمجية.',
  'landing.rule.1.t': 'لا جلسة بلا تحضير وموافقة سارية',
  'landing.rule.1.d': 'الخادم يرفض بدء الجلسة، لا الزر.',
  'landing.rule.2.t': 'العيون الأربع',
  'landing.rule.2.d': 'مراجعة أولى ثم اعتماد نهائي، ومن كتب لا يراجع ما كتب.',
  'landing.rule.3.t': 'رقم الهوية لا يظهر أبداً',
  'landing.rule.3.d': 'مشفَّر في القاعدة، ويُعاد مقنَّعاً، وكل قراءة له تُسجَّل.',
  'landing.rule.4.t': 'التسجيل يُحذف بعد مدّته',
  'landing.rule.4.d': 'تلقائياً كل ليلة — وإن أخفق الحذف رُفع تنبيه حرج، لا صمت.',
  'landing.rule.5.t': 'الملاحظة الداخلية لا تصل الأسرة',
  'landing.rule.5.d': 'ثلاثة نصوص لثلاثة جماهير، يفصلها الخادم لا الشاشة.',
  'landing.rule.6.t': 'لا ناقل خارجي بلا عقد ومفاتيح',
  'landing.rule.6.d': 'لا صورة ولا رسالة ولا مال يغادر المنصة قبل ذلك.',
  'landing.public.kicker': 'بلا دخول',
  'landing.public.title': 'ما يمكنك فعله الآن',
  'landing.public.directory.t': 'دليل المؤسسات والمختصين',
  'landing.public.directory.d': 'من اختار الظهور علناً — مؤسسات وأخصائيون بتخصصاتهم ومدنهم.',
  'landing.public.verify.t': 'التحقق من شهادة أداء',
  'landing.public.verify.d': 'أدخل رمز الشهادة لترى نطاقها وفترتها وصلاحيتها — النطاق لا الدرجة.',
  'landing.public.register.t': 'حساب مهني جديد',
  'landing.public.register.d': 'للأخصائيين والمرشدين؛ يملكه صاحبه وينتقل معه بين المؤسسات.',
  'landing.footer.logoAlt': 'شعار رفرفة',
  'landing.footer.about': 'منصة رفرفة — منصةٌ عربيّةٌ متخصّصة في التربية الخاصة والتعليم والإرشاد، بمعايير مهنيةٍ عالية وحمايةٍ صارمة لبيانات الأطفال.',
  'landing.footer.signInCol': 'الدخول',
  'landing.footer.guardianActivate': 'وصلك رابط دعوة؟ فعّل حسابك',
  'landing.footer.guardianRegister': 'إنشاء حساب وليّ أمر',
  'landing.footer.privacy': 'البيانات تُعالَج وفق قانون حماية البيانات الشخصية الأردني رقم 24 لسنة 2023',

  /* ── غلاف شاشات الدخول ────────────────────────────────────────────── */
  'auth.headline': 'كل رفرفة تحمل إمكانية التغيير',
  'auth.tagline': 'الجميع يقدمون الخدمات ورفرفة تقدم الحلول',
  'auth.lede': 'المنصّة العربيّة المتكاملة لتشغيل التعليم والتربية الخاصة والإرشاد',
  'auth.foot': 'كل رفرفة تحمل إمكانية التغيير',

  /* ── شاشة الدخول ──────────────────────────────────────────────────── */
  'login.title': 'تسجيل الدخول',
  'login.email': 'البريد الإلكتروني',
  'login.password': 'كلمة المرور',
  'login.submit': 'دخول',
  'login.failed': 'تعذّر تسجيل الدخول — حاول مرة أخرى.',
  'login.selfServiceNote': 'حساب المنصة يُنشأ لك من إدارة مؤسستك — لا تسجيل ذاتي، عدا الأخصائيين والمرشدين:',
  'login.selfServiceLink': 'أنشئ حسابك المهني',
  'login.guardianNote': 'وليّ الأمر يبدأ بنفسه — أنشئ حسابك وأضف أولادك ثم اطلب ربطهم بمؤسساتهم:',
  'login.guardianLink': 'أنشئ حساب وليّ أمر',
  'login.lockoutNote': 'خمس محاولات فاشلة تقفل الحساب مؤقتاً، وكل محاولة تُسجَّل في سجل التدقيق.',

  /* ── صفحات الحالة ─────────────────────────────────────────────────── */
  'status.noContext.title': 'لا يوجد سياق عمل لحسابك بعد',
  'status.noContext.text': 'حسابك موجود لكنه غير مرتبط بمؤسسة، ولا يملك ملفاً مهنياً أو ارتباطاً بطالب. إن كنت تنتظر دعوة من مؤسسة فستصلك على بريدك، وإن كنت أخصائياً فأكمل ملفك المهني.',
  'status.noContext.action': 'فتح ملفي المهني',
  'status.forbidden.title': 'هذه الشاشة خارج صلاحياتك في هذه المؤسسة',
  'status.forbidden.withPermission': 'تتطلب صلاحية «{permission}» في المؤسسة النشطة حالياً. إن كان هذا خطأً فراجع إدارة مؤسستك — الصلاحيات ثابتة بالدور ولا تُمنح فردياً.',
  'status.forbidden.plain': 'إن كان هذا خطأً فراجع إدارة مؤسستك.',
  'status.forbidden.action': 'العودة إلى صفحتي الأولى',
  'status.notFound.title': 'الصفحة غير موجودة',
  'status.notFound.aside': 'قد يكون الرابط قديماً أو أُعيدت تسمية الصفحة.',
  'status.notFound.text': 'لم نجد هذا المسار في المنصة.',
  'status.notFound.action': 'العودة إلى الصفحة الأولى',

  /* ── الأدلة العامة ────────────────────────────────────────────────── */
  'directory.title': 'الأدلة العامة',
  'directory.sub': 'من اختار الظهور وحده — وبلا بيانات اتصال لأحد',
  'directory.error': 'تعذّر تحميل الأدلة الآن — أعد المحاولة بعد قليل.',
  'directory.jobs.title': 'فرص العمل',
  'directory.jobs.emptyTitle': 'لا فرص مفتوحة الآن',
  'directory.jobs.emptyText': 'حين تعلن مؤسسة عن دور مهني يظهر هنا فوراً.',
  'directory.jobs.applyHint': 'للتقدّم: سجّل حساباً مهنياً ثم تقدّم من «فرص العمل» في حسابك.',
  'directory.institutions.title': 'دليل المؤسسات',
  'directory.institutions.emptyTitle': 'لا مؤسسات مدرجة بعد',
  'directory.institutions.emptyText': 'الظهور هنا اختيار كل مؤسسة.',
  'directory.specialists.title': 'دليل الأخصائيين',
  'directory.specialists.emptyTitle': 'لا أخصائيون مدرجون بعد',
  'directory.specialists.emptyText': 'الظهور هنا اختيار كل أخصائي من ملفه المهني.',
  'directory.specialists.years': '{n} سنوات',
  'directory.specialists.verified': 'موثَّق',
  'directory.privacyNote': 'لا يظهر في هذه الأدلة بريد ولا هاتف ولا رقم هوية. التواصل يمرّ عبر المنصة: دعوةٌ يقبلها صاحب الحساب.',
  'kind.SPECIALIST': 'أخصائي',
  'kind.COUNSELOR': 'مرشد طلابي',

  /* ── التحقق من شهادة ──────────────────────────────────────────────── */
  'verify.title': 'التحقق من شهادة أداء',
  'verify.field': 'رقم الشهادة',
  'verify.hint': 'ثمانية أحرف فأكثر كما هي مطبوعة على الشهادة.',
  'verify.valid.title': 'شهادة صحيحة وسارية',
  'verify.k.holder': 'صاحبها',
  'verify.k.institution': 'المؤسسة',
  'verify.k.period': 'الفترة',
  'verify.k.issuedAt': 'أُصدرت',
  'verify.note': 'تُظهر الشهادة النطاق («متميّز» أو «جيد») لا الدرجة ولا الترتيب — فالتحقق يجيب «هل هي حقيقية وسارية؟» ولا يرتّب الناس على الملأ.',
  'verify.invalid.title': 'غير صالحة',
  'verify.invalid.hint': 'تحقّق من الرقم كما هو مطبوع على الشهادة.',
  'band.EXCELLENT': 'متميّز',
  'band.GOOD': 'جيد',

  /* ── صفحة المؤسسة العامة ──────────────────────────────────────────── */
  'pubInst.title': 'صفحة المؤسسة',
  'pubInst.license': 'ترخيص {n}',
  'pubInst.country': 'الأردن',
  'pubInst.tracks': 'المسارات المقدَّمة',
  'pubInst.authorities': 'شركاؤنا والجهات الداعمة',
  'pubInst.authorities.emptyTitle': 'لا شركاء ولا جهات داعمة معلنة',
  'pubInst.authorities.emptyText': 'لم تُعلن المؤسسة شركاءها والجهات الداعمة والمشرفة على صفحتها العامة.',
  'pubInst.note': 'هذه الصفحة تعرّف بالمؤسسة ولا تعرض أي بيانات عن الطلبة أو الكادر — تلك تبقى داخل المنصة لمن يخصّه الأمر.',
  'authority.STATUTORY_MANDATORY': 'جهة إلزامية',
  'authority.ELECTIVE_OPTIONAL': 'جهة اختيارية',

  /* ── بطاقة المركز العامة (المزيد من المعلومات) ─────────────────────── */
  'pubInst.logoAlt': 'شعار {name}',
  'pubInst.specialEd': 'بالكادر أخصائيو تربية خاصة',
  'pubInst.alsoSchool': 'ومدرسة — صباحيٌّ أكاديميّ',
  'pubInst.contact': 'الموقع والتواصل',
  'pubInst.address': 'العنوان',
  'pubInst.phone': 'الهاتف',
  'pubInst.email': 'البريد',
  'pubInst.website': 'الموقع الإلكتروني',
  'pubInst.map': 'الموقع على الخريطة',
  'pubInst.mapOpen': 'افتح الموقع في الخرائط',
  'pubInst.mapNone': 'لم يُحدَّد موقع على الخريطة بعد — اسأل المركز عن الطريق.',
  'pubInst.contactNone': 'لم يُعلن المركز بيانات تواصل على صفحته.',
  'pubInst.more': 'نبذة عن المؤسسة',
  'pubInst.about': 'نبذة',
  'pubInst.achievements': 'إنجازات',
  'pubInst.moreNone': 'لم يكتب المركز نبذةً بعد.',
  'pubInst.counts.students': 'عدد الطلبة',
  'pubInst.counts.staff': 'عدد الكادر',
  'pubInst.counts.note': 'عددان مجمَّعان أعلنهما المركز باختياره — ولا يظهر اسم طالب ولا اسم موظف على أي صفحة عامة.',
  'pubInst.gallery': 'ألبوم الصور',
  'pubInst.gallery.emptyTitle': 'لا صور معلنة',
  'pubInst.gallery.emptyText': 'لم يُعلن المركز ألبوم صوره — اسأله عن جولة في مقرّه.',
  'pubInst.galleryAlt': 'صورة من مقرّ {name}',

  /* ── دليل المؤسسات: الشعار والموقع ─────────────────────────────────── */
  'directory.institutions.mapOpen': 'الموقع على الخريطة',


  /* ── 0027 — السجلّات والمعرفة ── */
  'nav.app.requiredFields': 'الحقول الإجبارية',
  'nav.app.overview': 'لوحة المتابعة',
  'nav.app.news': 'الأخبار',
  'nav.app.goalBank': 'بنك الأهداف',
  'nav.platform.news': "أخبار المنصة",
  'nav.platform.goalBank': 'بنك أهداف المنصة',
  'nav.me.news': 'أخبار مؤسستي',

  /* ── الأخبار العامة (/news) وقسمها في الصفحة الأولى ── */
  'news.public.title': 'الأخبار',
  'news.public.empty.title': 'لا أخبار منشورة بعد',
  'news.public.by': 'من إدارة المنصة',
  'news.kind.ANNOUNCEMENT': 'إعلان',
  'news.kind.ACHIEVEMENT': 'إنجاز',
  /* ── الصفحة الرئيسية بعد إعادة التصميم (16 سبتمبر 2026) ───────────────
     الترتيب الذي طلبه صاحب المشروع: البنر ← تعريف موجز ← الشركاء ← الأخبار ←
     التواصل. والأبواب الأربعة في البنر نفسِه لا تحته — «يلقى كل شيء يبيه بوجهه». */
  'landing.nav.courses': 'الأكاديمية',
  'landing.nav.centers': 'المؤسسات',
  'landing.nav.specialists': 'الأخصائيون',
  'landing.nav.jobs': 'فرص العمل',
  'landing.nav.cadres': 'الكوادر',
  'landing.hero.join': 'ضُمّ مركزك أو مدرستك',
  'landing.doors.aria': 'الأبواب الأربعة',
  'landing.vision.t': 'رؤيتنا',
  'landing.vision.d': 'أن تكون رفرفة المساحة التي يلتقي فيها جميع أطراف منظومة التربية الخاصة والتعليم والإرشاد؛ من طفل وأسرة، إلى مركز ومدرسة ومختص ومعلم ومدرّب ومستشار وأخصائي مستقل، في منظومة واحدة تتيح لكل فرد أن يجد ما يحتاجه، ويقدّم ما يملك، وينمو في دوره، ويتصل بالآخرين بسهولة ووضوح.',
  'landing.mission.t': 'رسالتنا',
  'landing.mission.d': 'أن تكون رفرفة منظومة رقمية متكاملة تجمع احتياجات القطاع وأفراده ومؤسساته في مساحة واحدة، وتسهّل الوصول إلى الخدمات والمعرفة والخبرات والتدريب والاستشارات والفرص، وتدعم ملفات الطلبة ورحلاتهم، وتمكّن المختصين والمؤسسات والأسر من التواصل والتعاون والنمو، بما يجعل العمل في القطاع أكثر ترابطًا وتنظيمًا، ويمنح كل طرف الأدوات والفرص التي تساعده على أداء دوره وتطوير أثره.',
  'landing.purpose.aria': 'رؤية رفرفة ورسالتها',
  'public.backHome': 'العودة إلى الصفحة الرئيسية',
  'landing.door.centers2.t': 'المؤسسات',
  'landing.door.centers2.d': 'حين تبحث لطفلك عن مركز أو مدرسة، تجدها هنا — بخدماتها، ومواقعها، وطريقة التواصل معها.',
  'landing.door.centers2.meta': '{n} جهةً مُدرجة',
  'landing.door.centers2.metaEmpty': 'الدليل العلني للمؤسسات',
  'landing.door.specialists.t': 'الأخصائيون والاستشاريون',
  'landing.door.specialists.d': 'مختصون ومرشدون بحساباتٍ يملكونها، وشهاداتٍ موثَّقة، وتخصصاتٍ معلَنة.',
  'landing.door.specialists.meta': '{n} مختصاً معلَناً',
  'landing.door.specialists.metaEmpty': 'الدليل العلني للمختصين',
  'landing.door.academy.t': 'الأكاديمية',
  'landing.door.academy.d': 'دوراتٌ تدريبية وأكاديمياتٌ افتراضية معتمدة — للأخصائيين والأهل، بشهاداتٍ مُوثَّقة.',
  'landing.door.academy.meta': '{n} دورة — منها {free} مجانية',
  'landing.door.academy.metaEmpty': 'دوراتٌ وشهاداتٌ موثَّقة',
  'landing.door.consult.t': 'الاستشارات',
  'landing.door.consult.d': 'للأفراد بخصوصيةٍ تامة، وللأطفال والمراهقين وأسرهم — مختصون معتمدون، تختار التخصص وتحجز موعدك.',
  'landing.door.consult.meta': 'بجلسةٍ موثَّقة عن بُعد',
  'landing.nav.consult': 'الاستشارات',
  'landing.cta.signin': 'تسجيل دخول',
  'landing.door.consult.meta2': '{n} استشارياً بأسعارٍ معلَنة',
  'landing.strip.consult.t': 'احجز استشارة',
  'landing.strip.consult.d': 'اختر استشارياً من لائحته وسعرِه وسيرتِه، ثم اختر يومك ووقتك من تقويمه.',
  'landing.verify.title': 'تحقَّق قبل أن تثق',
  'landing.verify.lead': 'شهادةٌ بين يديك، أو اسمٌ يقول إنه مهنيٌّ على رفرفة — الرمز يقول الحقيقة بلا دخول وبلا وسيط.',
  'landing.verify.cert.t': 'شهادة دورة',
  'landing.verify.cert.d': 'أدخل رمز الشهادة لترى اسم صاحبها والدورة والجهة المُصدِرة وتاريخها.',
  'landing.verify.pro.t': 'شهادة أداءٍ مهني',
  'landing.verify.pro.d': 'أدخل رمز الشهادة لترى نطاقها والمؤسسة التي أصدرتها — بلا درجةٍ ولا ترتيب.',
  // «لماذا رفرفة؟» بنصّ مركز غايتنا (22 أكتوبر 2026): جوابٌ بسيطٌ تحت العنوان لا لوحٌ يُفتح
  'landing.why.title': 'لماذا رفرفة؟',
  'landing.why.lead': 'لأن العملية التعليمية والتأهيلية تحتاج إلى تكامل، لا إلى خدمات متفرقة.',
  'landing.why.more': 'ولأن مستقبل التعليم يحتاج إلى أكثر من مجرد أدوات رقمية: منظومة تربط الجميع، وتختصر الوقت والجهد، وترفع جودة الخدمات التعليمية والتأهيلية، وتضمن استمرارية التطور لجميع الأطراف.',
  'landing.start.title': 'ابدأ من هنا',
  'landing.start.lead': 'اخترْ صفتك، والباقي خطواتٌ قليلة.',
  'landing.about.title': 'من نحن؟',
  'landing.about.lead': 'رفرفة منظومةٌ رقميةٌ متكاملةٌ لتشغيل التعليم والتربية الخاصة والإرشاد — من مدارس ومراكز ومعلّمين وأخصائيين مستقلين واستشاريين — وربط جميع المستفيدين منهم في مساحةٍ واحدةٍ آمنة.',
  'landing.join.guardian': 'سجّل كوليّ أمر',
  'landing.join.center': 'ضُمّ مركزك أو مدرستك إلى رفرفة',
  'landing.centers.kicker': 'المُدرَجون',
  'landing.centers.title': 'مؤسسات على رفرفة',
  'landing.centers.lead': 'جهاتٌ تعمل على المنصة واختارت الظهور في دليلها العلني — وليست شركاءَ للمنصة بل تعمل عليها.',
  'landing.centers.all': 'كل المؤسسات',
  'landing.centers.empty': 'لم يختر أي مركزٍ الظهور العلني بعد — وحين يفعل يظهر هنا باسمه ومدينته.',
  'landing.courses.kicker': 'القسم الأكاديمي',
  'landing.courses.title': 'أحدث الدورات',
  'landing.courses.lead': 'دوراتٌ منشورة الآن — المدفوعة بسعرها، والمجانية خدمةً للمجتمع.',
  'landing.courses.all': 'افتح الأكاديمية',
  'landing.courses.empty': 'لا دورات منشورة بعد — وحين تُنشر أولُها تظهر هنا بمدّتها وشهادتها.',
  'landing.strip.jobs.t': 'فرص العمل',
  'landing.strip.jobs.d': 'وظائف تعلنها المراكز والمدارس — تقرؤها بلا حساب، وتتقدّم بحسابك المهني.',
  'landing.strip.verify.t': 'التحقّق من شهادة أو أكاديمية',
  'landing.strip.verify.d': 'أدخل الرمز فيصلك الجواب — بلا حسابٍ ولا دخول.',
  'landing.contact.kicker': 'التواصل',
  'landing.contact.title': 'تواصل معنا',
  'landing.contact.lead': 'أسئلة المراكز والشراكات والدعم — ومتابعتنا على شبكات التواصل.',
  'landing.contact.socialAria': 'حسابات رفرفة على شبكات التواصل',
  'landing.partners.kicker': 'معاً نصنع الأثر',
  'landing.partners.title': 'شركاء النجاح',
  'landing.partners.lede': 'الجهات والبرامج التي دعمت رفرفة منذ فكرتها الأولى.',
  'landing.news.kicker': 'من إدارة المنصة',
  'landing.news.title': 'آخر الأخبار',
  'landing.news.all': 'كل الأخبار',

  /* ── 0031 — المستفيد والاستشارات المدفوعة والمحفظة ── */
  'nav.me.services.browse': 'احجز استشارة',
  'nav.me.consultations': 'استشاراتي',
  'nav.me.myServices': 'خدماتي',
  'nav.me.availability': 'تقويمي',
  'nav.me.notifications': 'التنبيهات',
  'nav.me.studentMessages': 'رسائل الطلبة',
  'nav.app.messages': 'الرسائل',
  'nav.app.forms': 'النماذج الرقمية',
  'nav.app.attachments': 'رفع مرفق',
  'nav.me.wallet': 'محفظتي',
  'nav.platform.payouts': 'طلبات السحب',
  'nav.platform.finance': 'المالية',
  'nav.platform.complaints': 'شكاوى الاستشارات',
  'nav.platform.pricing': 'تسعير المنصة',
  /* 0032 · 0033 — التسجيل الأكاديمي والأكاديميات والدورات */
  'nav.platform.courseProviders': 'طلبات مقدّمي الدورات',
  'nav.platform.consultants': 'طلبات تفعيل الاستشارات',
  'nav.platform.academies': 'مراجعة الأكاديميات',
  'nav.platform.institutionRequests': 'طلبات تسجيل المراكز',
  'nav.me.courseProvider': 'التسجيل الأكاديمي',
  'nav.me.academy': 'أكاديميتي',
  'nav.me.academyManage': 'إدارة الأكاديمية',
  'nav.me.courses': 'دوراتي',
  'nav.me.browseCourses': 'الأكاديمية',
  'nav.me.enrollments': 'دوراتي المسجَّلة',
  'login.clientNote': 'المستفيد يدخل برقم جواله:',
  'login.clientLink': 'دخول المستفيدين',

  /* ── حاسبة التكاليف (صفحة عامة) ─────────────────────────────────────── */
  'calc.kicker': 'تقدير مبدئي',
  'calc.title': 'احسب تكلفتك التقديرية',
  'calc.lead': 'قدِّر اشتراكك الشهري والسنوي حسب نوع الجهة وعدد الطلبة — الحساب في متصفّحك ولا يخرج منه شيء.',
  'calc.mode': 'نوع الاشتراك',
  'calc.mode.center': 'مركز تربية خاصة',
  'calc.mode.school': 'إشراف مدرسي',
  'calc.mode.pro': 'مهني مستقل',
  'calc.students': 'عدد الطلبة',
  'calc.studentsHint': 'عدد المقاعد الحيّة المطلوبة.',
  'calc.terms': 'عدد الفصول الدراسية',
  'calc.termsHint': 'فصلان أو ثلاثة في السنة.',
  'calc.firstTerm': 'خصم الفصل الأول',
  'calc.firstTermHint': 'سعرٌ مخفَّض لمقعد الإشراف في الفصل الأول.',
  'calc.monthly': 'شهرياً',
  'calc.perMonth': 'لكل شهر',
  'calc.yearly': 'سنوياً',
  'calc.perYear': 'لكل سنة',
  'calc.perStudent': 'لكل طالب',
  'calc.zero': 'أضِف طلبة',
  'calc.breakdown': 'تفصيل الحساب',
  'calc.line.license': 'ترخيص المؤسسة: {amount} سنوياً.',
  'calc.line.seat': 'مقاعد الطلبة: {amount} شهرياً × {n} طالب × 12 شهراً.',
  'calc.line.supervision': 'مقاعد الإشراف: {amount} للفصل × {n} طالب × {terms} فصل.',
  'calc.line.supervisionFirst': 'الفصل الأول (مخفَّض): {amount} × {n} طالب.',
  'calc.line.pro': 'اشتراك المهني المستقل: {amount} شهرياً.',
  'calc.currency': 'كل المبالغ بالدولار الأمريكي.',
  'calc.disclaimer': 'هذا تقديرٌ استرشادي وليس عرضاً ملزماً؛ الفاتورة النهائية تصدر من المنصة حسب باقتك.',

  /* ── 18 سبتمبر 2026 — إعدادات الحساب ──────────────────────────────────── */
  "hero.hello": "أهلاً،",
  "hero.aria": "بطاقتي",
  "hero.changePhoto": "غيّر الصورة",
  "hero.photoSaved": "حُفظت صورتك.",
  "hero.photoFailed": "تعذّر رفع الصورة.",
  "hero.removePhoto": "أزل الصورة",
  "hero.photoRemoved": "أُزيلت الصورة.",
  "account.photo": "صورة الحساب",
  "account.photoHint": "PNG أو JPEG أو WebP حتى 5 م.ب — تظهر في صفحتك وقوائم زملائك.",
  "account.emailChange": "تغيير بريد الدخول",
  "account.emailNew": "البريد الجديد",
  "account.emailSend": "أرسل رمزاً إلى البريد الجديد",
  "account.emailSent": "أُرسل رمزٌ إلى البريد الجديد — اكتبه هنا.",
  "account.emailConfirm": "أكّد البريد الجديد",
  "account.emailChanged": "صار هذا بريدَ دخولك. سجّل الدخول به من جديد.",
  "account.emailChangeNote": "يصل رمزٌ إلى البريد الجديد، وبعد تأكيده يصير بريدَ دخولك وتُنهى جلساتك الحالية.",
  "auth.forgot": "نسيت كلمة المرور؟",
  "forgot.title": "استعادة كلمة المرور",
  "forgot.lede": "اكتب بريدك المسجَّل وسيصلك رمزٌ من ستة أرقام.",
  "forgot.send": "أرسل الرمز",
  "forgot.sent": "إن كان البريد مسجَّلاً فقد وصله رمزٌ صالحٌ عشر دقائق.",
  "forgot.code": "الرمز",
  "forgot.newPw": "كلمة المرور الجديدة",
  "forgot.reset": "عيّن كلمة المرور",
  "forgot.done": "تغيّرت كلمة مرورك — سجّل الدخول بها.",
  "forgot.back": "العودة إلى الدخول",
  'nav.me.account': 'إعدادات الحساب',
  'account.title': 'إعدادات الحساب',
  'account.subtitle': 'صورتك واسمك وجوالك وبريدك وكلمة مرورك.',
  'account.profile': 'بياناتي',
  'account.password': 'كلمة المرور',
  'account.fullName': 'الاسم الكامل',
  'account.phone': 'رقم الجوال',
  'account.phoneHint': 'أرقامٌ فقط، وقد يسبقها «+». تغييرُ الرقم يُسقط توثيقَه حتى تُثبت الرقم الجديد.',
  'account.phoneVerifiedHint': 'رقمٌ موثَّق.',
  'account.phoneInvalid': 'رقم الجوال بصيغةٍ غير صالحة — 9 إلى 15 رقماً.',
  'account.nameShort': 'الاسم قصيرٌ جداً.',
  'verify.email.title': 'وثّق بريدك الإلكتروني',
  'verify.phone.title': 'وثّق رقم جوالك',
  'verify.send': 'أرسل رمز التوثيق',
  'verify.sent': 'أُرسل الرمز — تحقّق من صندوقك.',
  'verify.checkInbox': 'أرسلنا رمزاً من ستّة أرقام إلى {target}. تحقّق من البريد الوارد ومن مجلّد الرسائل غير المرغوبة.',
  'verify.code': 'رمز التوثيق',
  'verify.confirm': 'أكّد التوثيق',
  'verify.resend': 'أعد الإرسال',
  'verify.needSix': 'الرمز ستّة أرقام.',
  'verify.done': 'تمّ توثيق القناة.',
  'verify.failed': 'تعذّر إتمام التوثيق.',
  'account.emailVerified': 'البريد موثَّق',
  'account.emailFixed': 'البريد الإلكتروني هو هويةُ دخولك ومفتاحُ الدعوات والربط، فلا يُغيَّر من هنا. لتغييره تواصل مع إدارة المنصة.',
  'account.yes': 'نعم',
  'account.no': 'لا',
  'account.save': 'احفظ بياناتي',
  'account.saved': 'حُفظت بياناتك.',
  'account.saveFailed': 'تعذّر حفظ البيانات.',
  'account.noChange': 'لا تغيير لحفظه.',
  'account.pwNote': 'تغييرُ كلمة المرور يُنهي كل جلساتك المفتوحة — بما فيها هذه — وستدخل من جديد بالكلمة الجديدة.',
  'account.pwCurrent': 'كلمة المرور الحالية',
  'account.pwNew': 'كلمة المرور الجديدة',
  'account.pwConfirm': 'تأكيد كلمة المرور الجديدة',
  'account.pwPolicy': '10 أحرف على الأقل، وتحوي حرفاً ورقماً.',
  'account.pwMismatch': 'التأكيد لا يطابق كلمة المرور الجديدة.',
  'account.pwFillAll': 'أكمل الحقول الثلاثة لتفعيل الزر.',
  'account.pwSave': 'غيّر كلمة المرور',
  'account.pwChanged': 'تغيّرت كلمة المرور — ادخل من جديد.',
  'account.pwFailed': 'تعذّر تغيير كلمة المرور.',

  /* ── حسابات إدارة المنصة ──────────────────────────────────────────────── */
  'nav.platform.contact': 'رسائل التواصل',
  'nav.platform.credentials': 'شهادات الكوادر',
  'nav.platform.callTest': 'الاتصال الرقمي',
  'nav.platform.partners': 'شركاء النجاح',
  'nav.platform.health': 'صحة التشغيل',
  'nav.platform.forms': 'قوالب النماذج',
  'nav.app.attendance': 'الحضور اليومي',
  'nav.platform.contentReports': 'بلاغات المحتوى',
  'nav.platform.growth': 'نموّ المنصة',
  'nav.platform.deletions': 'طلبات حذف الحسابات',
  'nav.platform.sandbox': 'الحسابات التجريبية',
  'nav.platform.accounts': 'الحسابات',
  'nav.platform.admins': 'حسابات الإدارة',
  'padmin.title': 'حسابات إدارة المنصة',
  'padmin.subtitle': 'إدارةُ المنصة وأقسامُها (خدمة المستفيدين · الأكاديميات · المراكز والمدارس · المال) بحساباتٍ مستقلة — ببريدٍ لا يحمل أي صفةٍ أخرى في المنصة. ولكل قسمٍ ما يخصّه وحده.',
  'padmin.create': 'أنشئ حساب إدارة',
  'padmin.email': 'البريد الإلكتروني',
  'padmin.fullName': 'الاسم',
  'padmin.password': 'كلمة مرور ابتدائية (اختياري)',
  'padmin.passwordHint': 'اتركها فارغة لتُولَّد كلمةٌ مؤقتة تظهر مرةً واحدة. في الحالين تُغيَّر عند أول دخول.',
  'padmin.created': 'أُنشئ الحساب.',
  'padmin.regranted': 'أُعيدت صفة الإدارة لحسابٍ قائم بلا تغيير كلمة مروره.',
  'padmin.tempTitle': 'كلمة المرور المؤقتة — تظهر مرةً واحدة',
  'padmin.tempBody': 'سلّمها لصاحب الحساب بطريقةٍ آمنة. لن تُعرض ثانيةً، وسيُلزَم بتغييرها عند أول دخول.',
  'padmin.mustChange': 'ينتظر أول دخول',
  'padmin.lastLogin': 'آخر دخول',
  'padmin.never': 'لم يدخل بعد',
  'padmin.empty': 'لا حسابات — وهذا لا يحدث: أنت هنا.',
  'padmin.fillRequired': 'أدخل البريد والاسم لتفعيل الزر.',

  /* ── جدول المواعيد ────────────────────────────────────────────────────── */
  'nav.app.schedule': 'تقويمي',
  'nav.app.scheduleAll': 'تقويم المؤسسة',
  'nav.me.calendar': 'تقويمي',
  'nav.app.staffAvailability': 'دوامي',
  'nav.app.homeTraining': 'التدريب المنزلي',
  'nav.app.cases': 'لوحة الحالات',
  'nav.app.transport': 'الباص',
  'nav.app.promotion': 'ترقية نهاية السنة',
  'nav.app.guardianInvitations': 'دعوات أولياء الأمور',
  'nav.app.staffAvailabilityAll': 'دوام الكادر',
  'schedule.title': 'جدول المواعيد',
  'schedule.mine': 'جدولي',
  'schedule.subtitle': 'جلسات التربية الخاصة والإرشاد المجدولة في الأسبوع — بتوقيت عمّان.',
  'schedule.staff': 'الكادر',
  'schedule.me': 'أنا',
  'schedule.today': 'اليوم',
  'schedule.prevWeek': 'الأسبوع السابق',
  'schedule.nextWeek': 'الأسبوع التالي',
  'schedule.week': 'أسبوع',
  'schedule.day': 'يوم',
  'schedule.empty': 'لا مواعيد في هذا الأسبوع.',
  'schedule.emptyHint': 'جدولة جلسةٍ جديدة تبدأ من صفحة الجلسات أو من الزرّ أعلاه.',
  'schedule.new': 'جدولة جلسة',
  'schedule.minutes': 'د',
  'schedule.count': '{n} موعد',
  'schedule.print': 'اطبع الأسبوع',

  /* ── إنشاء الحساب: اختيار النوع ──────────────────────────────────────── */
  'register.title': 'إنشاء حساب',
  'register.lead': 'اختر نوع الحساب أولاً — الباقي نموذجٌ واحد.',
  'register.guardian': 'وليّ أمر',
  'register.guardian.d': 'تُضيف طفلك وتطلب ربطه بمركزه.',
  'register.professional': 'حساب مهني',
  'register.professional.d': 'أخصائي · مرشد · استشاري · مدرّب',
  'register.center': 'مركز أو مدرسة',
  'register.center.d': 'طلبُ ضمّ مركزك أو مدرستك يصل إدارة المنصة.',
  'register.haveAccount': 'لي حسابٌ أصلاً',
  'login.registerNote': 'ليس لك حساب؟',
  'login.registerLink': 'أنشئ حساباً',
  'login.beneficiaryNote': 'المستفيد يدخل برقم جواله:',
  'login.beneficiaryLink': 'دخول المستفيدين',

  /* ── مراسلة وليّ الأمر ────────────────────────────────────────────────── */
  'gmsg.title': 'الرسائل',
  'gmsg.guardianTitle': 'رسائلي مع كادر {name}',
  'gmsg.staffTitle': 'الرسائل مع وليّ الأمر',
  'gmsg.to': 'إلى',
  'gmsg.body': 'نصّ الرسالة',
  'gmsg.send': 'أرسل',
  'gmsg.sent': 'أُرسلت الرسالة.',
  'gmsg.empty': 'لا رسائل بعد.',
  'gmsg.emptyGuardian': 'اكتب لأخصائيّ طفلك أو معلّمه — يصلهم تنبيهٌ ويردّون هنا.',
  'gmsg.emptyStaff': 'اكتب لوليّ الأمر — يصله تنبيهٌ ويردّ هنا.',
  'gmsg.noContacts': 'لا كادرَ مُسنَداً بعد لهذا الطفل في مؤسسته — يظهر هنا من يُسنَد إليه.',
  'gmsg.noGuardians': 'لا وليَّ أمرٍ مفعَّلاً لهذا الطالب في مؤسستك.',
  'gmsg.unread': 'غير مقروءة',
  'gmsg.markRead': 'عُلّمت مقروءة',
  'gmsg.institution': 'المؤسسة',
  'gmsg.limit': 'حتى ألفي حرف.',

  /* ── الطباعة ──────────────────────────────────────────────────────────── */
  'print.action': 'اطبع',
  'print.printedAt': 'طُبع في',
  'print.by': 'بواسطة',

  /* ── مبدّل المظهر (18 سبتمبر 2026) ───────────────────────────────────────── */
  'theme.toLight': 'الوضع النهاري',
  'theme.toDark': 'الوضع الليلي',

} as const;

/** معرِّف رسالة صالح — كل مفتاح موجود في القاموس العربي */
export type MessageId = keyof typeof ar;
